var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5002 0.5H13.0002H12.1502H11.5002C11.2002 0.5 11.0002 0.7 11.0002 1C11.0002 1.3 11.2002 1.5 11.5002 1.5H12.4002H13.5002C13.7502 1.5 13.9502 1.55 14.1502 1.65L7.3502 8.4C7.1502 8.6 7.1502 8.9 7.3502 9.1C7.5502 9.3 7.8502 9.3 8.0502 9.1L14.8502 2.35C14.9502 2.55 15.0002 2.75 15.0002 3V3.5V4.4V5C15.0002 5.3 15.2002 5.5 15.5002 5.5C15.8002 5.5 16.0002 5.3 16.0002 5V4.65V3.5V3C16.0002 1.6 14.9002 0.5 13.5002 0.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5 8C15.2 8 15 8.2 15 8.5V9.2V13.5V14C15 14.85 14.35 15.5 13.5 15.5H2.5C1.65 15.5 1 14.85 1 14V3C1 2.15 1.65 1.5 2.5 1.5H7.15H8C8.3 1.5 8.5 1.3 8.5 1C8.5 0.7 8.3 0.5 8 0.5H7.4H3H2.5C1.1 0.5 0 1.6 0 3V14C0 15.4 1.1 16.5 2.5 16.5H13.5C14.9 16.5 16 15.4 16 14V13.5V9V8.5C16 8.2 15.8 8 15.5 8Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.41eb255a13a11d2edf9701c52e3f10f8.svg";
export { ForwardRef as ReactComponent };